module.exports = __webpack_public_path__ + "static/media/portfolio-02 copy.4bf9bd7a.jpg";